import { apiClient } from '../client'
import type { ApiPaginatedResponse, ApiSuccessResponse } from '../../types/api'
import type { Comorbidity, ComorbidityFormPayload } from '../../types/comorbidity'

export const comorbidityService = {
  async list(params?: {
    with_trashed?: boolean
    only_trashed?: boolean
    is_active?: boolean
    search?: string
    page?: number
    per_page?: number
  }) {
    const { data } = await apiClient.get<
      ApiPaginatedResponse<Comorbidity> | ApiSuccessResponse<Comorbidity[]>
    >('/comorbidities', { params })
    return data
  },

  async create(payload: ComorbidityFormPayload) {
    const { data } = await apiClient.post<ApiSuccessResponse<Comorbidity>>('/comorbidities', payload)
    return data
  },

  async update(id: string, payload: ComorbidityFormPayload) {
    const { data } = await apiClient.put<ApiSuccessResponse<Comorbidity>>(`/comorbidities/${id}`, payload)
    return data
  },

  async remove(id: string) {
    const { data } = await apiClient.delete<ApiSuccessResponse<null>>(`/comorbidities/${id}`)
    return data
  },

  async restore(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<Comorbidity>>(`/comorbidities/${id}/restore`)
    return data
  },
}
